<template>

  <div class="py-4 container-fluid">
    <div class="row">

      <div class="col-md-8">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Crear Remision</p>
              <div class="ms-auto d-flex gap-2">
                <argon-button v-if="(user.role != '1' && isRemissionPending) || user.role === '1'" color="success"
                  size="sm" @click="save">Guardar</argon-button>
                <argon-button v-if="form.id > 0" color="secondary" size="sm" @click="openPdfModal">
                  <i class="fa fa-file-pdf me-1"></i> PDF
                </argon-button>
                <argon-button v-if="isRemissionPending && form.id > 0" color="success" size="sm" @click="confirm">Formalizar</argon-button>
                <argon-button v-if="isRemissionAccepted && form.id > 0" color="danger" size="sm" @click="devolution">Devolución</argon-button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12" style="position: relative;">
                <label for="example-text-input" class="form-control-label">Cliente</label>
                <div class="d-flex gap-2">
                  <select ref="clientSelect" class="form-select select2" style="width:100%;">
                  </select>
                  <argon-button color="success" size="sm" @click="openClientModal">
                    <i class="fa fa-user-plus"></i> 
                  </argon-button>
                </div>
              </div>

              <div class="col-md-6">
                <label for="document-type" class="form-control-label">Tipo de Documento</label>
                <select id="documentType" class="form-control" v-model="form.document_type" :disabled="form.client_id > 0">
                  <option value="" disabled>Seleccione un tipo de documento</option>
                  <option value="CC">Cédula de Ciudadanía (CC)</option>
                  <option value="CE">Cédula de Extranjería (CE)</option>
                  <option value="TI">Tarjeta de Identidad (TI)</option>
                  <option value="RC">Registro Civil (RC)</option>
                  <option value="PA">Pasaporte (PA)</option>
                  <option value="PEP">Permiso Especial de Permanencia (PEP)</option>
                  <option value="NIT">Número de Identificación Tributaria (NIT)</option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Número documento</label>
                <argon-input type="text" v-model="form.document" autocomplete="off" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Dirección</label>
                <argon-input type="text" v-model="form.address" autocomplete="off" />
              </div>

              <div class="col-md-3">
                <label for="remission-departamento" class="form-control-label">Departamento</label>
                <select
                  id="remission-departamento"
                  class="form-select"
                  v-model="form.departamento"
                >
                  <option value="" disabled>Seleccione</option>
                  <option v-for="dpto in departamentos" :key="dpto" :value="dpto">
                    {{ dpto }}
                  </option>
                </select>
              </div>

              <div class="col-md-3">
                <label for="remission-municipio" class="form-control-label">Ciudad</label>
                <select
                  id="remission-municipio"
                  class="form-select"
                  v-model="form.municipio"
                  :disabled="form.departamento === ''"
                >
                  <option value="" disabled>Seleccione</option>
                  <option v-for="city in ciudadesFiltradas" :key="city" :value="city">
                    {{ city }}
                  </option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Telefono</label>
                <argon-input type="text" v-model="form.phone" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Email</label>
                <argon-input type="text" v-model="form.email" />
              </div>

              <!-- <div class="col-md-6">
                <label for="example-select-input" class="form-control-label">Seleccionar tipo</label>
                <select v-model="form.type" class="form-control">
                  <option value="production">Producción</option>
                  <option value="return">Devolución</option>
                </select>
              </div> -->

              <div class="col-md-6" v-if="form.id > 0">
                <label for="remission-status" class="form-control-label">Estado</label>
                <select id="remission-status" class="form-select" v-model="form.status">
                  <option value="pendiente">Pendiente</option>
                  <option value="aceptado">Aceptado</option>
                  <option value="cancelado">Cancelado</option>
                  <option value="devolucion">Devolución</option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="remission-payment-method" class="form-control-label">Método de Pago</label>
                <select id="remission-payment-method" class="form-select" v-model="form.payment_method">
                  <option value="">Seleccione un método</option>
                  <option v-for="method in paymentMethods" :key="method" :value="method">
                    {{ method }}
                  </option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="remission-discount" class="form-control-label">Descuento (%)</label>
                <input
                  id="remission-discount"
                  v-model.number="form.discount_percent"
                  type="number"
                  class="form-control"
                  min="0"
                  max="100"
                  step="0.01"
                  placeholder="0"
                />
              </div>

              <div class="col-md-6">
                <label for="remission-flete" class="form-control-label">Flete</label>
                <input
                  id="remission-flete"
                  v-model.number="form.flete"
                  type="number"
                  class="form-control"
                  min="0"
                  step="0.01"
                  placeholder="0"
                />
              </div>

              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Observación</label>
                <ArgonTextarea type="text" v-model="form.observation" />
              </div>


            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4" v-if="form.id > 0">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Evidencias de Pago</p>
            </div>
          </div>
          <div class="card-body">
            <div class="mb-3">
              <label for="payment-evidence-upload" class="form-control-label">Subir evidencia</label>
              <input
                id="payment-evidence-upload"
                type="file"
                class="form-control"
                accept="image/*"
                @change="handleFileSelect"
                :disabled="!form.id"
              />
              <small class="text-muted">Solo archivos de imagen (JPG, PNG, etc.)</small>
            </div>
            
            <div v-if="paymentEvidences.length > 0" class="mt-3">
              <label class="form-control-label">Evidencias cargadas:</label>
              <div class="row">
                <div v-for="evidence in paymentEvidences" :key="evidence.id" class="col-12 mb-3">
                  <div class="card">
                    <div class="card-body p-2">
                      <div class="d-flex align-items-center">
                        <div class="me-3">
                          <img
                            :src="getEvidenceImageUrl(evidence)"
                            alt="Evidencia de pago"
                            class="img-thumbnail"
                            style="max-width: 80px; max-height: 80px; object-fit: cover;"
                          />
                        </div>
                        <div class="flex-grow-1">
                          <small class="text-muted d-block">
                            {{ formatDate(evidence.created_at) }}
                          </small>
                        </div>
                        <div>
                          <a
                            @click="deletePaymentEvidence(evidence.id)"
                            class="text-danger font-weight-bold cursor-pointer"
                            data-toggle="tooltip"
                            data-original-title="Eliminar evidencia"
                          >
                            <i class="fa fa-trash"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div v-else class="text-center text-muted mt-3">
              <small>No hay evidencias de pago cargadas</small>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-10">
        <div class="card" v-if="form.id != 0">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="text-uppercase mb-0">Lista de detalles</p>
              <argon-button v-if="user.role === '1' || user.role === '2'" color="success" size="sm" class="ms-auto"
                @click="addDetail">Agregar producto</argon-button>
            </div>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Producto</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Cantidad
                      </th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Precio
                      </th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Total
                      </th>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center"
                        v-if="(user.role !== '1' && isRemissionPending) || user.role === '1'">
                        Opciones
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="value in data.data" :key="value.id">
                      <td>
                        <div class="d-flex px-2 py-1">
                          <div class="d-flex flex-column justify-content-center">
                            <h6 class="mb-0 text-sm">{{ detailProductName(value) }}</h6>
                          </div>
                        </div>
                      </td>
                      <td class="align-middle text-center">
                        <div class="d-flex align-items-center justify-content-center gap-1">
                          <input
                            type="number"
                            class="form-control form-control-sm text-center"
                            style="width: 70px;"
                            v-model.number="value.quantity"
                            @change="updateQuantity(value)"
                            min="1"
                          />
                        </div>
                      </td>

                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ parseFloat(value.price ?? 0).toLocaleString('es-ES', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          }) }}
                        </span>
                      </td>

                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ parseFloat(value.total ?? 0).toLocaleString('es-ES', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          }) }}
                        </span>
                      </td>

                      <td class="align-middle text-center" v-if="user.role === '1' || user.role === '2'">

                        <a @click="editRegister(value)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                           data-toggle="tooltip" data-original-title="Editar registro">
                          <i class="fa fa-pencil-alt"></i>
                        </a>

                        <a @click="deleteRegister(value.id)"
                          class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                          data-toggle="tooltip" data-original-title="Eliminar registro">
                          <i class="fa fa-trash"></i>
                        </a>
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Pagos y abonos -->
        <div class="card mb-2 mt-2" v-if="form.id != 0">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="text-uppercase mb-0">Pagos y Abonos</p>
              <argon-button
                v-if="(user.role != '1' && isRemissionPending) || user.role == '1'"
                color="success"
                size="sm"
                class="ms-auto"
                @click="openPaymentModal"
              >
                Agregar Pago
              </argon-button>
            </div>
          </div>
          <div class="card-body">
            <!-- Desglose detallado de la venta -->
            <div class="row mb-2 pb-2 border-bottom">
              <div class="col-md-3 col-6">
                <p class="mb-0 text-sm text-muted">
                  <strong>Subtotal:</strong> {{ formatCurrency(remissionSubtotal) }}
                </p>
              </div>
              <div class="col-md-3 col-6" v-if="form.discount_percent > 0">
                <p class="mb-0 text-sm text-muted">
                  <strong>Descuento ({{ form.discount_percent }}%):</strong>
                  <span class="text-danger">−{{ formatCurrency(remissionDiscountAmount) }}</span>
                </p>
              </div>
              <div class="col-md-3 col-6" v-if="form.flete > 0">
                <p class="mb-0 text-sm text-muted">
                  <strong>Flete:</strong>
                  <span class="text-info">+{{ formatCurrency(form.flete) }}</span>
                </p>
              </div>
              <div class="col-md-3 col-6">
                <p class="mb-0 text-sm">
                  <strong>Total Venta:</strong> {{ formatCurrency(remissionTotal) }}
                </p>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-4">
                <p class="mb-0 text-sm">
                  <strong>Total Pagado:</strong>
                  <span :class="totalPaid >= remissionTotal ? 'text-success' : ''">
                    {{ formatCurrency(totalPaid) }}
                  </span>
                </p>
              </div>
              <div class="col-md-4">
                <p class="mb-0 text-sm">
                  <strong>Pendiente:</strong>
                  <span :class="pendingAmount > 0 ? 'text-danger' : 'text-success'">
                    {{ formatCurrency(pendingAmount) }}
                  </span>
                </p>
              </div>
              <div class="col-md-4" v-if="form.payment_method">
                <p class="mb-0 text-sm">
                  <strong>Método de pago:</strong> {{ form.payment_method }}
                </p>
              </div>
            </div>
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Monto</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Modo de pago</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Observación</th>
                    <th
                      v-if="(user.role != '1' && isRemissionPending) || user.role == '1'"
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center"
                    >
                      Opciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="payment in payments" :key="payment.id">
                    <td>
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ formatDate(payment.payment_date) }}
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ formatCurrency(payment.amount) }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ payment.payment_method || '—' }}
                    </td>
                    <td>
                      <span class="text-secondary text-xs">
                        {{ payment.observation || '-' }}
                      </span>
                    </td>
                    <td
                      v-if="(user.role != '1' && isRemissionPending) || user.role == '1'"
                      class="align-middle text-center"
                    >
                      <a
                        @click="editPayment(payment)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer"
                        data-toggle="tooltip"
                        data-original-title="Editar pago"
                      >
                        <i class="fa fa-pencil-alt"></i>
                      </a>
                      <a
                        @click="deletePayment(payment.id)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;"
                        data-toggle="tooltip"
                        data-original-title="Eliminar pago"
                      >
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>
                  <tr v-if="!payments || payments.length === 0">
                    <td colspan="5" class="text-center text-secondary text-sm">
                      No hay pagos registrados
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Agregar/Editar Pago -->
    <div class="modal fade" id="ModalRemissionPayment" tabindex="-1" aria-labelledby="remissionPaymentModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="remissionPaymentModalLabel">
              {{ paymentForm.id ? 'Editar Pago' : 'Agregar Pago' }}
            </h5>
            <button type="button" class="btn-close" @click="closePaymentModal"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="mb-3">
                <label for="remission-payment-amount" class="form-label">Monto</label>
                <input
                  id="remission-payment-amount"
                  v-model.number="paymentForm.amount"
                  type="number"
                  step="0.01"
                  class="form-control"
                  placeholder="Ingrese el monto del pago"
                  required
                />
              </div>
              <div class="mb-3">
                <label for="remission-payment-date" class="form-label">Fecha del Pago</label>
                <input
                  id="remission-payment-date"
                  v-model="paymentForm.payment_date"
                  type="date"
                  class="form-control"
                  required
                />
              </div>
              <div class="mb-3">
                <label for="remission-payment-method" class="form-label">Modo de pago</label>
                <select
                  id="remission-payment-method"
                  v-model="paymentForm.payment_method"
                  class="form-select"
                  required
                >
                  <option value="" disabled>Seleccione un modo de pago</option>
                  <option v-for="method in paymentMethods" :key="method" :value="method">
                    {{ method }}
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label for="remission-payment-observation" class="form-label">Observación</label>
                <textarea
                  id="remission-payment-observation"
                  v-model="paymentForm.observation"
                  class="form-control"
                  placeholder="Ingrese una observación (opcional)"
                  rows="3"
                ></textarea>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closePaymentModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="savePayment">Guardar Pago</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Agregar Cliente -->
    <div class="modal fade" id="ModalClient" tabindex="-1" aria-labelledby="clientModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="clientModalLabel">Agregar Cliente</h5>
            <button type="button" class="btn-close" @click="closeClientModal"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="mb-3">
                <label for="client-name" class="form-label">Nombre</label>
                <input type="text" v-model="newClient.name" id="client-name" class="form-control"
                  placeholder="Ingrese el nombre del cliente" required>
              </div>
              <div class="mb-3">
                <label for="client-document-type" class="form-label">Tipo de Documento</label>
                <select id="client-document-type" class="form-select" v-model="newClient.document_type">
                  <option value="" disabled>Seleccione un tipo de documento</option>
                  <option value="CC">Cédula de Ciudadanía (CC)</option>
                  <option value="CE">Cédula de Extranjería (CE)</option>
                  <option value="TI">Tarjeta de Identidad (TI)</option>
                  <option value="RC">Registro Civil (RC)</option>
                  <option value="PA">Pasaporte (PA)</option>
                  <option value="PEP">Permiso Especial de Permanencia (PEP)</option>
                  <option value="NIT">Número de Identificación Tributaria (NIT)</option>
                </select>
              </div>
              <div class="mb-3">
                <label for="client-document" class="form-label">Número de Documento</label>
                <input type="text" v-model="newClient.document" id="client-document" class="form-control"
                  placeholder="Ingrese el número de documento" required>
              </div>
              <div class="mb-3">
                <label for="client-address" class="form-label">Dirección</label>
                <input type="text" v-model="newClient.address" id="client-address" class="form-control"
                  placeholder="Ingrese la dirección">
              </div>
              <div class="mb-3">
                <label for="client-phone" class="form-label">Teléfono</label>
                <input type="text" v-model="newClient.phone" id="client-phone" class="form-control"
                  placeholder="Ingrese el teléfono" required>
              </div>
              <div class="mb-3">
                <label for="client-email" class="form-label">Email</label>
                <input type="email" v-model="newClient.email" id="client-email" class="form-control"
                  placeholder="Ingrese el email" required>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeClientModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="saveClient">Guardar Cliente</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal agregar detalles de remision -->
    <div class="modal fade" id="ModalBudget" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Agregar producto</h5>
            <button type="button" class="btn-close" @click="submitForm" ></button>
          </div>
          <div class="modal-body">
            <form>


              <div class="mb-3">
                <label for="amount" class="form-label">Producto</label>
                <select ref="ModelSelect" class="form-select select2" style="width:100%;">
                </select>
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Cantidad</label>
                <input type="text" v-model="modal.quantity" id="total_price" class="form-control"
                  placeholder="Ingrese el valor total">
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Precio Unidad</label>
                <input type="text" v-model="formattedPrice" id="amount" class="form-control"
                  placeholder="Ingrese el valor">
              </div>
              <div class="mb-3">
                <label for="amount" class="form-label">Total</label>
                <input type="text" v-model="totalPrice" id="total_price" class="form-control"
                  placeholder="Ingrese el valor total">
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitForm">Guardar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal PDF -->
    <div class="modal fade" id="ModalPdf" tabindex="-1" aria-labelledby="pdfModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="pdfModalLabel">Datos para PDF</h5>
            <button type="button" class="btn-close" @click="closePdfModal"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="mb-3">
                <label class="form-label d-block">Tipo de pago</label>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" id="al_cobro" value="Al cobro" v-model="pdfForm.tipo_pago">
                  <label class="form-check-label" for="al_cobro">Al cobro</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" id="pago_en_casa" value="Pago en Casa" v-model="pdfForm.tipo_pago">
                  <label class="form-check-label" for="pago_en_casa">Pago en Casa</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" id="contado" value="Contado" v-model="pdfForm.tipo_pago">
                  <label class="form-check-label" for="contado">Contado</label>
                </div>
              </div>

              <div class="mb-3">
                <label for="pdf-valor" class="form-label">Valor</label>
                <input
                  id="pdf-valor"
                  v-model="pdfForm.valor"
                  type="text"
                  class="form-control"
                  placeholder="$0"
                />
              </div>

              <div class="mb-3">
                <label for="pdf-obs" class="form-label">Obs.</label>
                <input
                  id="pdf-obs"
                  v-model="pdfForm.obs"
                  type="text"
                  class="form-control"
                  placeholder="Ingrese observación"
                />
              </div>

              <div class="mb-3">
                <label for="pdf-metodo" class="form-label">Método</label>
                <select id="pdf-metodo" v-model="pdfForm.metodo" class="form-select">
                  <option value="EFECTIVO">EFECTIVO</option>
                  <option value="NEQUI">NEQUI</option>
                </select>
              </div>

              <div class="mb-3">
                <label class="form-label d-block">Más envío</label>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" id="envio_si" value="SI" v-model="pdfForm.mas_envio">
                  <label class="form-check-label" for="envio_si">SI</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" id="envio_no" value="NO" v-model="pdfForm.mas_envio">
                  <label class="form-check-label" for="envio_no">NO</label>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closePdfModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="generatePdf">Generar PDF</button>
          </div>
        </div>
      </div>
    </div>
  </div>



</template>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonTextarea from "../../../components/ArgonTextarea.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'select2/dist/css/select2.css';
import 'select2';
import { Modal } from 'bootstrap';
import { POS_PAYMENT_METHODS } from '@/utils/posTicketPrint';


const body = document.getElementsByTagName("body")[0];

export default {
  name: "Remissions Create",
  data() {
    return {
      showMenu: false,
      modalBudget: null,
      isFinish: false,
      filter: {
        production_id: [],
        model_id: [],
        oficio_id: [],
        user_id: [],
      },
      models: [],
      user: {},
      form: {
        id: 0,
        name: '',
        client_id: 0,
        document_type:'',
        document:'',
        address:'',
        departamento: '',
        municipio: '',
        phone: '',
        email: '',
        observation: '',
        status: 'pendiente',
        order_status: 'pendiente',
        type: 'production',
        discount_percent: 0,
        flete: 0,
        payment_method: '',
      },
      ciudades: [],
      data: {},
      modal: {
        id: 0,
        remission_id: 0,
        model_id: 0,
        quantity: 0,
        price: 0,
        total: 0
      },
      modalEvidencia: [],
      suppliers: [],
      filteredSuppliers: [],
      clients: [],
      suppressClientSync: false,
      clientModal: null,
      newClient: {
        id: 0,
        name: '',
        document_type: '',
        document: '',
        address: '',
        phone: '',
        email: '',
        role: '4', // Cliente
        status: '1',
        password: 'cliente123',
        password_confirmation: 'cliente123',
        payment: '0',
        processes: [],
      },
      payments: [],
      paymentMethods: POS_PAYMENT_METHODS,
      paymentModal: null,
      paymentForm: {
        id: 0,
        remission_id: 0,
        amount: 0,
        payment_date: new Date().toISOString().split('T')[0],
        payment_method: POS_PAYMENT_METHODS[0],
        observation: '',
      },
      paymentEvidences: [],
      selectedPaymentEvidence: null,
      pdfModal: null,
      pdfForm: {
        tipo_pago: '',
        valor: '0',
        obs: 'Venta POS',
        metodo: 'EFECTIVO',
        mas_envio: 'NO',
      },
    };
  },
  components: { ArgonInput, ArgonButton, ArgonTextarea },
  computed: {
    formattedPrice: {
      get() {
        return this.modal.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        this.modal.price = Math.floor(value.replace(/\./g, "") || 0);
        this.modal.total = Math.floor(this.modal.price * this.modal.quantity);
      },
    },
    totalPrice: {
      get() {
        return this.modal.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        this.modal.total = Math.floor(value.replace(/\./g, "") || 0);
        this.modal.price = this.modal.quantity > 0 ? Math.floor((this.modal.total / this.modal.quantity)) : 0;
      },
    },
    remissionSubtotal() {
      const rows = this.data?.data || [];
      return rows.reduce((sum, item) => sum + (parseFloat(item.total) || 0), 0);
    },
    remissionDiscountAmount() {
      const discount = parseFloat(this.form.discount_percent) || 0;
      if (discount <= 0) {
        return 0;
      }
      return this.remissionSubtotal * (Math.min(100, discount) / 100);
    },
    remissionTotal() {
      const discount = parseFloat(this.form.discount_percent) || 0;
      const flete = parseFloat(this.form.flete) || 0;
      const afterDiscount = discount > 0
        ? this.remissionSubtotal * (1 - Math.min(100, discount) / 100)
        : this.remissionSubtotal;
      return afterDiscount + flete;
    },
    totalPaid() {
      return this.payments.reduce((sum, payment) => sum + (parseFloat(payment.amount) || 0), 0);
    },
    pendingAmount() {
      return this.remissionTotal - this.totalPaid;
    },
    isRemissionPending() {
      return this.normalizeRemissionStatus(this.form.status) === 'pendiente';
    },
    isRemissionAccepted() {
      return this.normalizeRemissionStatus(this.form.status) === 'aceptado';
    },
    // Departamentos únicos del mismo ciudades.json que usa el catálogo
    departamentos() {
      const set = new Set(this.ciudades.map((c) => c.DPTO));
      return Array.from(set).sort((a, b) => a.localeCompare(b, 'es'));
    },
    ciudadesFiltradas() {
      if (!this.form.departamento) return [];
      return this.ciudades
        .filter((c) => c.DPTO === this.form.departamento)
        .map((c) => c.NOMBRE)
        .sort((a, b) => a.localeCompare(b, 'es'));
    },
  },
  watch: {
    "modal.quantity"(newQuantity) {
      this.modal.total = Math.floor(this.modal.price * newQuantity);
    },
    // Al cambiar de departamento, la ciudad seleccionada puede dejar de ser válida.
    // Si ciudades aún no carga (edición), se valida al terminar loadCiudades.
    "form.departamento"() {
      this.validateMunicipio();
    },
    $route(to) {
      if (to.name !== 'Remissions Create') {
        return;
      }
      this.bootstrapForm(to);
    },
  },
  methods: {
    detailProductName(detail) {
      if (detail?.inventory?.name) {
        return detail.inventory.name;
      }
      if (detail?.inventory?.invoice_name) {
        return detail.inventory.invoice_name;
      }
      if (detail?.inventory_id) {
        return `Producto #${detail.inventory_id}`;
      }
      return 'No encontrado';
    },
    normalizeRemissionStatus(status) {
      if (status === 0 || status === '0') {
        return 'pendiente';
      }
      if (status === 1 || status === '1') {
        return 'aceptado';
      }
      if (status === 'pendiente' || status === 'aceptado' || status === 'cancelado' || status === 'devolucion') {
        return status;
      }
      return 'pendiente';
    },
    async loadCiudades() {
      try {
        // Mismo archivo de ciudades que usa el catálogo (public/ciudades.json)
        const res = await fetch(`${process.env.BASE_URL}ciudades.json?v=${Date.now()}`);
        const data = await res.json();
        this.ciudades = Array.isArray(data) ? data : [];
      } catch (error) {
        console.error('Error al cargar las ciudades:', error);
        this.ciudades = [];
      }
      this.validateMunicipio();
    },
    validateMunicipio() {
      if (
        this.ciudades.length > 0 &&
        this.form.municipio &&
        this.form.departamento &&
        !this.ciudadesFiltradas.includes(this.form.municipio)
      ) {
        this.form.municipio = '';
      }
    },
    async getClients() {
      try {
        // Obtener todos los usuarios con role 4 (clientes)
        const response = await this.$store.dispatch('users/getAll');
        let users = [];
        
        // El backend devuelve directamente un array cuando page=all
        if (Array.isArray(response)) {
          users = response;
        } else if (response && response.data) {
          // Si viene con estructura de respuesta
          if (Array.isArray(response.data)) {
            users = response.data;
          } else if (response.data.data && Array.isArray(response.data.data)) {
            users = response.data.data;
          }
        }
        
        // Filtrar solo clientes (role == '4')
        this.clients = users.filter(user => user.role == '4');
        
        this.$nextTick(() => {
          const select = $(this.$refs.clientSelect);
          
          if (select.hasClass("select2-hidden-accessible")) {
            select.select2('destroy');
          }
          select.empty();
          select.append('<option value="" disabled selected>Seleccionar cliente</option>');
          
          this.clients.forEach(client => {
            const displayText = `${client.name} - ${client.email || client.phone || ''}`;
            select.append(new Option(displayText, client.id, false, false));
          });
          
          select.select2({
            placeholder: 'Seleccione un cliente',
            allowClear: true,
          });
          
          select.on('change', () => {
            // Al cargar una venta existente, los datos de la remisión (dirección, teléfono,
            // etc.) son la fuente de verdad y no deben sobrescribirse con los del cliente.
            if (this.suppressClientSync) {
              return;
            }
            const selectedId = select.val();
            if (selectedId) {
              const selectedClient = this.clients.find(c => c.id == selectedId);
              if (selectedClient) {
                this.form.client_id = selectedClient.id;
                this.form.name = selectedClient.name;
                this.form.email = selectedClient.email || '';
                this.form.phone = selectedClient.phone || '';
                this.form.address = selectedClient.address || '';
                this.form.document = selectedClient.document || '';
                this.form.document_type = selectedClient.document_type || '';
              }
            } else {
              this.form.client_id = 0;
              this.form.name = '';
              this.form.email = '';
              this.form.phone = '';
              this.form.address = '';
              this.form.document = '';
              this.form.document_type = '';
            }
          });
          
          // Si hay un cliente seleccionado, establecerlo
          if (this.form.client_id > 0) {
            select.val(this.form.client_id).trigger('change');
          }
        });
      } catch (error) {
        console.error('Error al obtener clientes:', error);
      }
    },
    openClientModal() {
      // Resetear el formulario del nuevo cliente
      this.newClient = {
        id: 0,
        name: '',
        document_type: '',
        document: '',
        address: '',
        phone: '',
        email: '',
        role: '4',
        status: '1',
        password: 'cliente123',
        password_confirmation: 'cliente123',
        payment: '0',
        processes: [],
      };
      
      const modalElement = document.getElementById('ModalClient');
      this.clientModal = new Modal(modalElement);
      this.clientModal.show();
    },
    closeClientModal() {
      if (this.clientModal) {
        this.clientModal.hide();
      }
    },
    async saveClient() {
      try {
        // Validar campos requeridos
        if (!this.newClient.name || !this.newClient.email || !this.newClient.phone) {
          await Swal.fire({
            icon: 'warning',
            title: 'Campos requeridos',
            text: 'Por favor complete todos los campos obligatorios.',
            confirmButtonText: 'Aceptar'
          });
          return;
        }
        
        // Crear el cliente en usuarios
        const response = await this.$store.dispatch('users/save', this.newClient);
        
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El cliente ha sido registrado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          });
          
          // Recargar la lista de clientes
          await this.getClients();
          
          // Seleccionar el nuevo cliente
          this.$nextTick(() => {
            const select = $(this.$refs.clientSelect);
            select.val(response.data.id).trigger('change');
          });
          
          this.closeClientModal();
        } else {
          throw new Error(response.data?.message || 'Error al guardar el cliente');
        }
      } catch (error) {
        console.error("Error al crear el cliente:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al guardar el cliente',
        });
      }
    },
    async getModels(editId = null) {
      // Obtener productos de inventory
      const response = await this.$store.dispatch('inventory/getAll');
      
      let products = [];
      if (Array.isArray(response)) {
        products = response;
      } else if (response && response.data) {
        products = Array.isArray(response.data) ? response.data : [];
      }

      this.$nextTick(() => {
        const select = $(this.$refs.ModelSelect);

        if (select.hasClass("select2-hidden-accessible")) {
          select.select2('destroy');
        }
        select.empty();
        select.append('<option value="" disabled selected>Seleccionar producto</option>');
        
        // Filtrar solo productos con stock mayor a cero, pero incluir siempre el producto que se está editando
        const productsWithStock = products.filter(prod => {
          const stock = parseFloat(prod.quantity || prod.stock || 0);
          return stock > 0 || (editId !== null && prod.id == editId);
        });
        
        // Guardar los productos filtrados para usarlos después
        this.models = { data: productsWithStock };
        
        productsWithStock.forEach(prod => {
          const displayText = `#${prod.id} - ${prod.name || 'Sin nombre'} (${prod.ref || 'Sin ref'}) - STOCK: ${prod.quantity || 0}`;
          select.append(new Option(displayText, prod.id, false, false));
        });

        $(this.$refs.ModelSelect).select2({
          placeholder: 'Seleccione un producto',
          allowClear: false,
          dropdownParent: $('#ModalBudget .modal-body')
        });

        $(this.$refs.ModelSelect).on('change', () => {
          this.modal.model_id = $(this.$refs.ModelSelect).val();

            const selectedModel = this.models.data.find(prod => prod.id == this.modal.model_id );

            if (selectedModel) {
              this.modal.price = parseFloat(selectedModel.price || selectedModel.precio1 || 0);

              if(this.modal.id==0){
                this.modal.quantity = selectedModel.quantity || 1;
              }

             this.modal.total = Math.floor(this.modal.price * this.modal.quantity);
          }
        });
      });
    },
    addDetail() {
      this.modal.id = 0;
      this.modal.remission_id = this.form.id; // Establecer el ID de la remisión
      this.modal.production_id = 0;
      this.modal.model_id = 0;
      this.modal.quantity = 0;
      this.modal.price = 0;
      this.modal.total = 0;

      // Verificar que la remisión tenga un ID
      if (!this.form.id || this.form.id === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Debe guardar la remisión primero antes de agregar productos.',
          confirmButtonText: 'Aceptar'
        });
        return;
      }

      this.getModels();
      $(this.$refs.ModelSelect).val("").trigger('change');

      this.openModal();
    },
    openModal() {
      const modalElement = document.getElementById('ModalBudget');
      this.modalBudget = new Modal(modalElement); // Guarda la instancia del modal
      this.modalBudget.show(); // Muestra el modal
    },
    closeModal() {
      if (this.modalBudget) {
        this.modalBudget.hide(); // Cierra el modal
      }
    },
    async getData() {
      this.data = await this.$store.dispatch('remissionsDetails/getData', this.form.id);
    },
    async getPayments() {
      if (!this.form.id) {
        this.payments = [];
        return;
      }
      try {
        const payments = await this.$store.dispatch('remissionPayments/getAll', {
          remission_id: this.form.id,
        });
        this.payments = payments || [];
      } catch (error) {
        console.error('Error al obtener pagos:', error);
        this.payments = [];
      }
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(Number(value) || 0);
    },
    formatDate(date) {
      if (!date) return '—';
      return new Date(date).toLocaleDateString('es-CO');
    },
    openPaymentModal() {
      this.paymentForm = {
        id: 0,
        remission_id: this.form.id,
        amount: 0,
        payment_date: new Date().toISOString().split('T')[0],
        payment_method: POS_PAYMENT_METHODS[0],
        observation: '',
      };
      const modalElement = document.getElementById('ModalRemissionPayment');
      this.paymentModal = new Modal(modalElement);
      this.paymentModal.show();
    },
    closePaymentModal() {
      if (this.paymentModal) {
        this.paymentModal.hide();
      }
    },
    editPayment(payment) {
      this.paymentForm = {
        id: payment.id,
        remission_id: payment.remission_id,
        amount: payment.amount,
        payment_date: payment.payment_date
          ? payment.payment_date.split('T')[0]
          : new Date().toISOString().split('T')[0],
        payment_method: payment.payment_method || POS_PAYMENT_METHODS[0],
        observation: payment.observation || '',
      };
      const modalElement = document.getElementById('ModalRemissionPayment');
      this.paymentModal = new Modal(modalElement);
      this.paymentModal.show();
    },
    async savePayment() {
      try {
        if (!this.paymentForm.amount || this.paymentForm.amount <= 0) {
          await Swal.fire({
            icon: 'warning',
            title: 'Campo requerido',
            text: 'Por favor ingrese un monto válido.',
            confirmButtonText: 'Aceptar',
          });
          return;
        }

        if (!this.paymentForm.payment_date) {
          await Swal.fire({
            icon: 'warning',
            title: 'Campo requerido',
            text: 'Por favor seleccione una fecha de pago.',
            confirmButtonText: 'Aceptar',
          });
          return;
        }

        if (!this.paymentForm.payment_method) {
          await Swal.fire({
            icon: 'warning',
            title: 'Campo requerido',
            text: 'Por favor seleccione un modo de pago.',
            confirmButtonText: 'Aceptar',
          });
          return;
        }

        const response = await this.$store.dispatch('remissionPayments/save', this.paymentForm);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El pago ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          });
          this.closePaymentModal();
          await this.getPayments();
        } else {
          throw new Error(response.data?.message || 'Error al guardar el pago');
        }
      } catch (error) {
        console.error('Error al guardar el pago:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al guardar el pago',
        });
      }
    },
    async deletePayment(id) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar',
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch('remissionPayments/delete', id);
          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire('Eliminado!', 'El pago ha sido eliminado correctamente.', 'success');
            await this.getPayments();
          } else {
            throw new Error(response.data?.message || 'Error al eliminar el pago');
          }
        }
      } catch (error) {
        console.error('Error al eliminar el pago:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al eliminar el pago',
        });
      }
    },
    async confirm() {
      // Verificar que la remisión tenga un ID
      if (!this.form.id || this.form.id === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Debe guardar la remisión primero antes de formalizarla.',
          confirmButtonText: 'Aceptar'
        });
        return;
      }

      // Verificar que tenga detalles
      if (!this.data.data || this.data.data.length === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Debe agregar al menos un producto antes de formalizar la remisión.',
          confirmButtonText: 'Aceptar'
        });
        return;
      }

      const result = await Swal.fire({
        icon: 'info',
        title: 'Formalizar remisión',
        text: 'Al formalizar la remisión se restará la cantidad del stock disponible en los productos de producción. Ya no se podrá editar los registros ni los detalles de la remisión.',
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        backdrop: true,
      });

      if (result.isConfirmed) {
        try {
          const response = await this.$store.dispatch("remissions/formalize", this.form.id);
          
          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'La remisión ha sido formalizada correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
            }).then(() => {
              // Actualizar el estado del formulario
              this.form.status = 'aceptado';
              this.getData();
              this.getPayments();
            });
          } else {
            throw new Error(response.data?.message || 'Error al formalizar la remisión');
          }
        } catch (error) {
          console.error("Error al formalizar la remisión:", error);
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.response?.data?.message || error.message || 'Error al formalizar la remisión',
            confirmButtonText: 'Aceptar'
          });
        }
      }
    },
    async devolution() {
      if (!this.form.id || this.form.id === 0) {
        await Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Debe guardar la remisión primero.',
          confirmButtonText: 'Aceptar'
        });
        return;
      }

      const result = await Swal.fire({
        icon: 'warning',
        title: '¿Confirmar devolución?',
        html: 'Se cambiará el estado de la remisión y del pedido a <b>Devolución</b> y se reintegrará el stock de los productos al inventario. Esta acción no se puede deshacer.',
        showCancelButton: true,
        confirmButtonText: 'Sí, registrar devolución',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#d33',
      });

      if (!result.isConfirmed) return;

      try {
        const payload = {
          ...this.form,
          status: 'devolucion',
          order_status: 'devolucion',
        };

        const response = await this.$store.dispatch("remissions/save", payload);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Devolución registrada!',
            text: 'El stock ha sido reintegrado al inventario.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          });

          this.form.status = 'devolucion';
          this.form.order_status = 'devolucion';
          this.getData();
          this.getPayments();
        } else {
          throw new Error(response?.data?.message || 'Error al registrar la devolución');
        }
      } catch (error) {
        console.error("Error al registrar devolución:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al registrar la devolución',
          confirmButtonText: 'Aceptar'
        });
      }
    },
    async save() {
      if (this.form.status === 'devolucion') {
        const result = await Swal.fire({
          icon: 'warning',
          title: '¿Confirmar devolución?',
          html: 'Se cambiará el estado a <b>Devolución</b> y se reintegrará el stock de los productos al inventario. Esta acción no se puede deshacer.',
          showCancelButton: true,
          confirmButtonText: 'Sí, registrar devolución',
          cancelButtonText: 'Cancelar',
          confirmButtonColor: '#d33',
        });
        if (!result.isConfirmed) return;
      }
      try {
        // Si hay un cliente seleccionado pero no existe en usuarios, crearlo
        if (this.form.name && this.form.client_id == 0) {
          // Verificar si el cliente ya existe por email o nombre
          const existingClient = this.clients.find(c => 
            c.email === this.form.email || c.name === this.form.name
          );
          
          if (!existingClient && this.form.email && this.form.name) {
            // Crear el cliente en usuarios
            const clientData = {
              id: 0,
              name: this.form.name,
              email: this.form.email,
              phone: this.form.phone || '',
              address: this.form.address || '',
              document_type: this.form.document_type || 'CC',
              document: this.form.document || '',
              role: '4', // Cliente
              status: '1',
              password: 'cliente123',
              password_confirmation: 'cliente123',
              payment: '0',
              processes: [],
            };
            
            const clientResponse = await this.$store.dispatch('users/save', clientData);
            
            if (clientResponse && clientResponse.status >= 200 && clientResponse.status < 300) {
              this.form.client_id = clientResponse.data.id;
              // Recargar la lista de clientes
              await this.getClients();
            }
          } else if (existingClient) {
            this.form.client_id = existingClient.id;
          }
        }
        
        if (this.form.client_id > 0) {
          this.form.user_id = this.form.client_id;
        }

        const remissionPayload = {
          ...this.form,
          address: this.form.address ?? '',
          phone: this.form.phone ?? '',
          observation: this.form.observation ?? '',
        };

        if (this.form.status === 'devolucion') {
          remissionPayload.order_status = 'devolucion';
        }

        // Dispara la acción de Vuex para guardar la remisión
        const response = await this.$store.dispatch("remissions/save", remissionPayload);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {

              this.form = response.data;
              this.form.id = response.data.id || 0;
              this.form.client_id = response.data.user_id || this.form.client_id;
              this.form.address = response.data.address ?? '';
              this.form.departamento = response.data.departamento ?? '';
              this.form.municipio = response.data.municipio ?? '';
              this.form.phone = response.data.phone ?? '';
              this.form.observation = response.data.observation ?? '';
              this.form.status = this.normalizeRemissionStatus(response.data.status);
              this.form.order_status = response.data.order_status || 'pendiente';
              this.form.discount_percent = parseFloat(response.data.discount_percent) || 0;
              this.form.flete = parseFloat(response.data.flete) || 0;

              if (this.modal.remission_id === 0) {
                this.modal.remission_id = this.form.id;
              }

              this.getData();
              this.getPayments();
              this.getPaymentEvidences();

            }
          });

        } else {
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        console.error("Error al crear el proyecto:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el proyecto',
        });
      }
    },
    async submitForm() {
      try {

        const selectedModel = this.models.data.find(prod => prod.id == this.modal.model_id );

        if (selectedModel && this.modal.quantity > (selectedModel.quantity || selectedModel.stock || 0)) {
          Swal.fire({
            icon: 'warning',
            title: 'Cantidad excedida',
            text: 'La cantidad ingresada supera el stock disponible.',
            confirmButtonText: 'Aceptar'
          });
          return;
        }

        const payload = {
          id: this.modal.id,
          remission_id: this.modal.remission_id,
          inventory_id: this.modal.model_id,
          quantity: this.modal.quantity,
          price: this.modal.price,
          total: this.modal.total,
        };

        // Dispara la acción de Vuex para guardar el modal
        const response = await this.$store.dispatch("remissionsDetails/save", payload);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {

              this.modal.id = 0;
              this.modal.production_id = 0;
              this.modal.model_id = 0;
              this.modal.quantity = 0;
              this.modal.price = 0;
              this.modal.total = 0;

              $(this.$refs.processesSelect).val('').trigger('change');

              this.getData();
              this.closeModal();
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }

    },
    async editRegister(params) {
      this.modal = {
        id: params.id,
        remission_id: this.form.id,
        model_id: params.inventory_id,
        quantity: params.quantity,
        price: params.price,
        total: params.total,
      };

      await this.getModels(this.modal.model_id);

      this.openModal();

      await new Promise(resolve => setTimeout(resolve, 300));

      const select = $(this.$refs.ModelSelect);
      if (this.modal.model_id) {
        select.val(this.modal.model_id).trigger('change');
      }
    },
    async updateQuantity(value) {
      if (!value.id || !value.quantity || value.quantity < 1) {
        return;
      }

      const newTotal = Math.round(parseFloat(value.price) * value.quantity * 100) / 100;

      try {
        const payload = {
          id: value.id,
          remission_id: value.remission_id,
          inventory_id: value.inventory_id,
          quantity: value.quantity,
          price: parseFloat(value.price),
          total: newTotal,
        };

        const response = await this.$store.dispatch('remissionsDetails/save', payload);

        if (response && response.status >= 200 && response.status < 300) {
          const item = this.data.data.find(d => d.id === value.id);
          if (item) {
            item.total = newTotal;
          }
        } else {
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: response?.data?.message || 'No se pudo actualizar la cantidad.',
          });
          await this.getData();
        }
      } catch (error) {
        console.error('Error al actualizar cantidad:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'No se pudo actualizar la cantidad.',
        });
        await this.getData();
      }
    },
    async deleteRegister(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("remissionsDetails/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getData();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    resolveEditParams(route) {
      if (route.query?.id) {
        return { id: route.query.id };
      }

      const dataEdit = route.params?.data;
      if (!dataEdit) {
        return null;
      }

      try {
        return JSON.parse(dataEdit);
      } catch (error) {
        console.error('Error al parsear los datos del registro:', error);
        return null;
      }
    },
    applyRemissionToForm(params) {
      this.form.id = params.id || 0;
      this.form.name = params.name || '';
      this.form.client_id = params.user_id || params.client_id || 0;
      this.form.user_id = this.form.client_id || null;
      this.form.document_type = params.document_type || '';
      this.form.document = params.document || '';
      this.form.address = params.address || '';
      this.form.departamento = params.departamento || '';
      this.form.municipio = params.municipio || '';
      this.form.phone = params.phone || '';
      this.form.email = params.email || '';
      this.form.type = params.type || 'production';
      this.form.observation = params.observation || '';
      this.form.status = this.normalizeRemissionStatus(params.status);
      this.form.order_status = params.order_status || 'pendiente';
      this.form.discount_percent = parseFloat(params.discount_percent) || 0;
      this.form.flete = parseFloat(params.flete) || 0;
      this.form.payment_method = params.payment_method || '';
      this.modal.remission_id = params.id || 0;

      this.$nextTick(() => {
        if (this.form.client_id > 0 && this.$refs.clientSelect) {
          const select = $(this.$refs.clientSelect);
          // Solo actualizar el display del select: los datos del formulario ya vienen
          // de la remisión guardada (snapshot de la venta), no del registro del cliente.
          this.suppressClientSync = true;
          select.val(this.form.client_id).trigger('change');
          this.suppressClientSync = false;
        }
      });
    },
    async loadEditRemission(id) {
      const response = await this.$store.dispatch('remissions/getData', id);
      const remission = response?.data;

      if (!remission?.id) {
        throw new Error('No se encontró la remisión.');
      }

      this.applyRemissionToForm(remission);
      await Promise.all([this.getData(), this.getPayments(), this.getPaymentEvidences()]);
    },
    async bootstrapForm(route) {
      await this.getClients();

      const params = this.resolveEditParams(route);
      if (!params?.id) {
        return;
      }

      this.getModels();

      try {
        if (route.query?.id) {
          await this.loadEditRemission(params.id);
        } else {
          this.applyRemissionToForm(params);
          await Promise.all([this.getData(), this.getPayments(), this.getPaymentEvidences()]);
        }
      } catch (error) {
        console.error('Error al cargar la remisión:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || error?.message || 'No se pudo cargar la remisión.',
        });
      }
    },
    async printRemission(id, pdfData = null) {
      try {
        const response = await this.$store.dispatch("remissions/getPdf", { id, pdfData });
        
        // Crear una URL del archivo recibido
        const url = window.URL.createObjectURL(new Blob([response.data]));
        
        // Crear un enlace para descargar el archivo
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Remision_${id}.pdf`); // Nombre del archivo
        document.body.appendChild(link);
        link.click();
        
        // Limpiar la URL creada
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
      } catch (error) {
        console.error("Error al generar el PDF:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'Error al generar el PDF de la remisión',
        });
      }
    },
    async getPaymentEvidences() {
      if (!this.form.id) {
        this.paymentEvidences = [];
        return;
      }
      try {
        const evidences = await this.$store.dispatch('remissionPaymentEvidences/getAll', {
          remission_id: this.form.id,
        });
        this.paymentEvidences = evidences || [];
      } catch (error) {
        console.error('Error al obtener evidencias de pago:', error);
        this.paymentEvidences = [];
      }
    },
    handleFileSelect(event) {
      const file = event.target.files[0];
      if (file) {
        if (!file.type.startsWith('image/')) {
          Swal.fire({
            icon: 'warning',
            title: 'Archivo inválido',
            text: 'Por favor seleccione solo archivos de imagen.',
            confirmButtonText: 'Aceptar'
          });
          return;
        }
        this.selectedPaymentEvidence = file;
        this.uploadPaymentEvidence();
      }
    },
    async uploadPaymentEvidence() {
      if (!this.selectedPaymentEvidence || !this.form.id) {
        return;
      }
      try {
        const formData = new FormData();
        formData.append('image', this.selectedPaymentEvidence);
        formData.append('remission_id', this.form.id);

        const response = await this.$store.dispatch('remissionPaymentEvidences/save', formData);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'La evidencia de pago ha sido cargada correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          });
          this.selectedPaymentEvidence = null;
          await this.getPaymentEvidences();
        } else {
          throw new Error(response.data?.message || 'Error al cargar la evidencia de pago');
        }
      } catch (error) {
        console.error('Error al cargar la evidencia de pago:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al cargar la evidencia de pago',
        });
      }
    },
    async deletePaymentEvidence(id) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar',
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch('remissionPaymentEvidences/delete', id);
          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire('Eliminado!', 'La evidencia de pago ha sido eliminada correctamente.', 'success');
            await this.getPaymentEvidences();
          } else {
            throw new Error(response.data?.message || 'Error al eliminar la evidencia de pago');
          }
        }
      } catch (error) {
        console.error('Error al eliminar la evidencia de pago:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al eliminar la evidencia de pago',
        });
      }
    },
    getEvidenceImageUrl(evidence) {
      const apiUrl = process.env.VUE_APP_API_IMAGE_URL || 'http://localhost:8000/storage/';
      if (evidence.image_url) {
        // If image_url is already a full URL, return it as is
        if (evidence.image_url.startsWith('http')) {
          return evidence.image_url;
        }
        // If it's a relative path, prepend the API URL (which already includes /storage/)
        return `${apiUrl}${evidence.image_url}`;
      }
      if (evidence.image) {
        // If image is already a full URL, return it as is
        if (evidence.image.startsWith('http')) {
          return evidence.image;
        }
        // If it's a relative path, prepend the API URL (which already includes /storage/)
        return `${apiUrl}${evidence.image}`;
      }
      return '';
    },
    openPdfModal() {
      if (!this.pdfModal) {
        this.pdfModal = new Modal(document.getElementById('ModalPdf'));
      }
      this.pdfModal.show();
    },
    closePdfModal() {
      if (this.pdfModal) {
        this.pdfModal.hide();
      }
    },
    async generatePdf() {
      await this.printRemission(this.form.id, this.pdfForm);
      this.closePdfModal();
    },
  },
  async mounted() {
    this.user = JSON.parse(localStorage.getItem('user'));

    this.loadCiudades();
    const route = useRoute();
    await this.bootstrapForm(route);

    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>

<style>
.disabled-link {
  color: gray;
  pointer-events: none;
  /* Impide la interacción */
  cursor: not-allowed;
  /* Cambia el cursor para indicar que está deshabilitado */
}
</style>
